import React, { useEffect, useState, useRef } from "react";
import VirtualClassSvg from "../svg/VirtualClassSvg";
import EmptyBoxSvg from "../svg/EmptyBoxSvg";
import PageNav from "../components/PageNav";
import Featured from "../components/Featured";
import CopyIcon from "../svg/CopyIcon";
import axios from "axios";
// import { CopyToClipboard } from "react-copy-to-clipboard";
import { vitualClassListModel } from "../models/dashboardModel";
import classNames from "classnames";
import { animated, useSpring } from "react-spring";
import loadingSpin from "../images/loadingSpin.gif";
import EmptyContent from "../components/common/EmptyContent";

const VirtualClassroom = () => {
  const [AvailableClasses, setAvailableVitualClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [iframeLink, setIframeLink] = useState("");
  const [copyText, setCopyText] = useState(false);
  const copyRef = useRef(null);

  const schoolDomain = localStorage.getItem("schoolDomain");
  const id = JSON.parse(localStorage.getItem("studentInfo"));
  const admissionnumber = id[0].admissionnumber;

  const getVitualClass = async () => {
    const queryData = {
      admissionnumber,
      SchoolUrl: schoolDomain,
      deploymentIdx: id[0].schoolidx,
    };
    try {
      setLoading(true);
      const { data } = await axios.post("student/virtualclassroom", queryData);
      if (data.status) {
        // console.log(data.data);
        let vClasses = vitualClassListModel(data);
        // console.log(vClasses, "ff");
        setAvailableVitualClasses(vClasses[0]);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  useEffect(() => {
    getVitualClass();
    return () => {};
  }, []);

  const showNoNotes = classNames({
    "flex justify-center w-full mt-16": true,
    hidden: loading,
  });

  const Heading = () => (
    <>
      <span className="text-base sm:text-2xl leading-7 text-white mt-1">
        Virtual Classroom
      </span>
    </>
  );

  const pageSvg = () => (
    <>
      <VirtualClassSvg />
    </>
  );

  const showCopyNotificatn = () => {
    setTimeout(() => {
      setCopyText(false);
    }, 1000);
  };

  const onCopy = (link, index, array) => {
    navigator.clipboard.writeText(link);
    // console.log(index, link.toString());

    setCopyText(true);
    showCopyNotificatn();
  };

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: "translateX(0)" }],
    from: { opacity: 0, transform: "translateX(80px)" },
    config: { duration: 1000 },
  });

  return (
    <div className="px-4 sm:flex sm:px-0 mb-4">
      <div className="w-full sm:w-2/3 sm:pl-2">
        <animated.div style={transitionStyles}>
          <PageNav Heading={Heading} PageSvg={pageSvg} />
        </animated.div>
        {iframeLink === "" ? (
          <>
            {AvailableClasses.length > 0 ? (
              AvailableClasses.map((lecture, index, array) => (
                <div
                  className="bg-white rounded-lg px-4 py-6 mt-6 shadow-lg relative"
                  key={index}
                >
                  <div className="sm:flex justify-between">
                    <span className="text-sm sm:text-base font-semibold text-gray-100 leading-5">
                      {lecture.subject} Classroom Link
                    </span>
                    <div className="flex justify-between text-gray-400 text-sm sm:text-base mt-2 sm:mt-0 leading-5 font-semibold">
                      <span className="mr-5">
                        {lecture.date}, {lecture.time}
                      </span>
                      <span> {lecture.duration} </span>
                    </div>
                  </div>
                  {/* {copyText && copyText.toString() !== lecture.classLink.toString() && <span className='absolute top-0'>link copied!</span>} */}
                  <div
                    ref={copyRef}
                    className="w-full sm:flex justify-between rounded-lg items-center sm:pl-2 mt-4"
                  >
                    <div className="w-full sm:w-5/6 bg-gray-700 rounded-lg px-4 sm:px-6 py-4 text-gray-200 text-xs sm:text-sm leading-5 mr-4">
                      <div className="w-full text-xs truncate">
                        {" "}
                        {lecture.classLink}{" "}
                      </div>
                    </div>
                    <div
                      onClick={() => onCopy(lecture.classLink, index, array)}
                      className="sm:flex items-center w-1/6 cursor-pointer hidden sm:visible"
                    >
                      <span className="text-xs text-blue-100 font-semibold leading-4 mr-4">
                        copy link
                      </span>
                      <span className="">
                        <CopyIcon />
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div
                      className="w-32 sm:w-40 rounded bg-blue-900 font-semibold flex justify-center cursor-pointer text-xs text-blue-100 py-2 px-4 sm:mr-0 mt-4"
                      // href={lecture.classLink}
                      onClick={() => {
                        if (/\.whereby\.com/i.test(lecture.classLink)) {
                          return setIframeLink(lecture.classLink)
                        }

                        window.open(lecture.classLink, "_blank");
                      }}
                      target="_blank"
                    >
                      Open link
                    </div>
                    <span
                      onClick={() => onCopy(lecture.classLink)}
                      className="sm:hidden mt-4 sm:mt-0 flex items-center cursor-pointer sm:w-1/6"
                    >
                      <span className="text-xs text-blue-100 font-semibold leading-4 mr-1 sm:mr-4">
                        copy link
                      </span>
                      <span className="">
                        <CopyIcon />
                      </span>
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <>
                {loading && (
                  <div className="flex justify-center w-full my-24">
                    <img src={loadingSpin} alt="loading..." />
                  </div>
                )}
                <div className={showNoNotes}>
                  <EmptyContent
                    message="No links"
                    moreMessage="Virtual links created will show here"
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <div className="w-full" style={{ height: "70%" }}>
            <div className="flex items-center justify-end">
              <div
                className="w-32 sm:w-40 rounded bg-blue-900 font-semibold flex justify-center cursor-pointer text-xs text-blue-100 py-2 px-4 sm:mr-0 my-4"
                // href={lecture.classLink}
                onClick={() => setIframeLink("")}
                target="_blank"
              >
                Close link
              </div>
            </div>
            <iframe src={iframeLink} className="w-full h-full iframeLoader" title="Edves Virtual Classroom" allow="camera;microphone;display-capture" />
          </div>
        )}
      </div>
      <div className="w-full sm:w-1/3 sm:mx-4 mt-6">
        <Featured />
      </div>
    </div>
  );
};

export default VirtualClassroom;
